import { render, staticRenderFns } from "./Opens.vue?vue&type=template&id=6fea982e&lang=pug"
import script from "./Opens.vue?vue&type=script&lang=js"
export * from "./Opens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports